import { useEffect, useState } from 'react'

interface Link {
  href?: string
  method?: string
  rel?: string
}
interface reviewsOverview {
  attributes?: any[]
  links?: Link[]
  numberOfReviews: {
    fiveStars: number
    fourStars: number
    oneStar: number
    threeStars: number
    total: number
    twoStars: number
  }
  starsAverage: number
}

export const useTrustpilotReviews = (isProductPage: boolean, sku?: string) => {
  const [businessId, setBusinessId] = useState()
  const [reviews, setReviews] = useState<any>({})
  const [reviewsOverview, setReviewsOverview] = useState<reviewsOverview | undefined>()
  const [orderBy, setOrderBy] = useState('createdat.desc')
  const [filterStars, setFilterStars] = useState<number | undefined>()
  const stars = filterStars ? `&stars=${filterStars}` : ''

  let fetchUrl: string | undefined
  if (isProductPage) {
    fetchUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${businessId}/reviews?sku=${sku}`
  } else {
    if (!sku) {
      fetchUrl = `https://api.trustpilot.com/v1/business-units/${businessId}/reviews?orderBy=${orderBy}${stars}`
    }
  }

  useEffect(() => {
    fetch(
      'https://api.trustpilot.com/v1/business-units/find?name=sofiaandgrace.com',
      {
        method: 'GET',
        headers: new Headers({
          apikey: 'Q2ka1Ag9mSigjQNACgG5If4YEsUoZh9I'
        })
      }
    )
      .then(async (res) => res.json())
      .then(response => {
        setBusinessId(response.id)
      })
      .catch(error => console.log(error)) // eslint-disable-line
  }, [])

  useEffect(() => {
    if (businessId) {
      if (fetchUrl) {
        fetch(
          fetchUrl,
          {
            method: 'GET',
            headers: new Headers({
              apikey: 'Q2ka1Ag9mSigjQNACgG5If4YEsUoZh9I'
            })
          }
        )
          .then(async (res) => res.json())
          .then(response => {
            setReviews(response)
          })
            .catch(error => console.log(error)) // eslint-disable-line
      }

      if (isProductPage || sku) {
        fetch(
            `https://api.trustpilot.com/v1/product-reviews/business-units/${businessId}?sku=${sku}`,
            {
              method: 'GET',
              headers: new Headers({
                apikey: 'Q2ka1Ag9mSigjQNACgG5If4YEsUoZh9I'
              })
            }
        )
          .then(async (res) => res.json())
          .then(response => {
            setReviewsOverview(response)
          })
            .catch(error => console.log(error)) // eslint-disable-line
      }
    }
    // eslint-disable-next-line
  }, [businessId, orderBy, filterStars])

  return {
    businessId,
    reviews,
    reviewsOverview,
    setOrderBy,
    setFilterStars
  }
}
